import { Languages } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
export default function LanguageToggle({dark=false}) {
  const {language,setLanguage,t}=useLanguage();
  return <div aria-label={t("language")} className={`inline-flex items-center gap-1 rounded-full border p-1 ${dark?"border-white/25 bg-white/10 text-white":"border-[#D8D1C4] bg-white text-[#0B1F3A]"}`}>
    <Languages size={14} className="mx-1"/>
    {["en","es"].map(code=><button type="button" key={code} onClick={()=>setLanguage(code)} className={`h-7 px-2.5 rounded-full text-xs font-semibold ${language===code?(dark?"bg-white text-[#0B1F3A]":"bg-[#0B1F3A] text-white"):"opacity-65"}`}>{code.toUpperCase()}</button>)}
  </div>;
}
